import { render, staticRenderFns } from "./MainListFilters.vue?vue&type=template&id=27c6ea04&"
import script from "./MainListFilters.vue?vue&type=script&lang=js&"
export * from "./MainListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c6ea04')) {
      api.createRecord('27c6ea04', component.options)
    } else {
      api.reload('27c6ea04', component.options)
    }
    module.hot.accept("./MainListFilters.vue?vue&type=template&id=27c6ea04&", function () {
      api.rerender('27c6ea04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainListFilters.vue"
export default component.exports